// export const LS_VIBIA_TOKEN = 'vibia.spa.token'
// export const LS_VIBIA_REFRESH_TOKEN = 'vibia.spa.refreshToken'
export const ONBOARDING_DONE = 'onBoardingDone'
